export const progressBarAnimationSetup = (gsap, ScrollTrigger) => {
    return window.addEventListener('DOMContentLoaded', function () {
        console.debug('Progress bar script loaded');
        gsap.registerPlugin(ScrollTrigger);
        const sections = document.querySelectorAll('.spv-campaignPage__chapter');
        let scrollTriggers = [];
        const createScrollTriggers = () => {
            gsap.utils.toArray(sections).forEach((section, index) => {
                const typedSection = section;
                const timelineContainer = typedSection.querySelector('.spv-campaignPage__timeline');
                const progressBar = timelineContainer?.querySelector('.spv-campaignPage__timeline-progress');
                const progressDot = timelineContainer?.querySelector('.spv-campaignPage__timeline-dot');
                const progressLine = progressBar?.querySelector('.spv-campaignPage__timeline-progress-line');
                if (!progressBar || !progressDot || !progressLine)
                    return;
                const trigger = ScrollTrigger.create({
                    trigger: section,
                    start: '20 top',
                    end: index === sections.length - 1 ? `bottom top` : 'bottom bottom',
                    scrub: 0.3,
                    animation: gsap.fromTo(progressDot, {
                        left: '2px',
                    }, {
                        left: progressBar.offsetWidth - 14 + 'px',
                    }),
                });
                scrollTriggers.push(trigger);
            });
        };
        const handleResize = () => {
            scrollTriggers.forEach(trigger => trigger.kill());
            scrollTriggers = [];
            createScrollTriggers();
            ScrollTrigger.refresh();
        };
        createScrollTriggers();
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = window.setTimeout(handleResize, 250);
        });
    });
};
//# sourceMappingURL=progress-bar.js.map